import { S as Swiper, A as A11y, N as Navigation } from './a11y-6-j8Uj_3.js?v=4b10b5d456af';
import { P as Pagination } from './pagination-BCYG-xz7.js?v=7e1e5f6374ee';
import { R } from './fancybox.esm-BlQ23Aaz.js?v=c0c2c436fab6';

if (!customElements.get('product-media')) {
  class ProductMedia extends HTMLElement {
    constructor() {
      super();
      this.swiper();
      this.fancybox();
    }

    swiper() {
      // Check if Swiper exists
      if (typeof Swiper == 'undefined') {
        return false;
      }

      // Get swiper element
      this.swiperElement = this.querySelector('[data-product-media-swiper]');

      // Swiper options
      this.swiperOptions = {
        modules: [A11y, Navigation, Pagination],
        threshold: 10,
        direction: 'horizontal',
        pagination: {
          el: '.swiper-pagination-product-media',
          type: 'bullets',
          clickable: true,
        },
      };

      // Init swiper
      this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);

      // Rebuid Swiper in design mode
      if (Shopify.designMode && this.swiperInstance) {
        window.addEventListener('shopify:section:load', () => {
          this.swiperInstance.update();
        });
      }
    }

    /*
     * Create fancybox
     */
    fancybox() {
      // Check if Fancybox exists
      if (typeof R == 'undefined') {
        return false;
      }

      R.bind('[data-fancybox]', {
        animated: false,
        showClass: false,
        mainClass: 'image-zoom',
        mainStyle: {
          '--f-toolbar-padding': '16px 32px',
          '--f-toolbar-gap': '8px',
          '--f-button-border-radius': '50%',
          '--f-thumb-width': '82px',
          '--f-thumb-height': '82px',
          '--f-thumb-opacity': '0.5',
          '--f-thumb-hover-opacity': '1',
          '--f-thumb-selected-opacity': '1',
        },
        Carousel: {
          Toolbar: {
            display: {
              right: ['toggleFull', 'close'],
            },
          },
        },
      });
    }
  }

  window.ProductMedia = ProductMedia;

  customElements.define('product-media', ProductMedia);
}
